import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { ShopAddonsLink } from '@app/router/constants';
import { useNavigate } from '@app/hooks';
import { selectCurrentShopAddon } from '@app/redux/addOns';

export const useShopRedirectIfNoSelection = () => {
  const { replace } = useNavigate();
  const currentShopAddon = useSelector(selectCurrentShopAddon);

  useEffect(() => {
    if (!currentShopAddon) {
      replace(`/${ShopAddonsLink.ShopAddons}`);
    }
  }, [replace, currentShopAddon]);
};
